// Moves theme-rendered blocks into a Ghost-written page body.
//
// A template can't write into the middle of {{content}}, so it renders
// the block after it and names where it belongs:
//
//   <div data-place-before="#marker, #read-more">…</div>
//
// The block moves to just before the first match in the page. If none is
// there (renamed or deleted in Ghost), or the block is empty, it
// stays where the template put it.

export default function place() {
    document.querySelectorAll("[data-place-before]").forEach((el) => {
        if (!el.firstElementChild) return;
        const target = document.querySelector(el.dataset.placeBefore);
        if (target) target.before(el);
    });
}
